import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Item from 'modules/attendance/components/SettingItemPage/TimeTracking/SettingsPanel/_Item'
import attendanceSettingsCollection from 'modules/attendance/store/collections/settings'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  selectedSetting: AttendanceSetting
  attendanceSettings: AttendanceSetting[]
  loading: boolean
  onChange: (newSetting: AttendanceSetting) => void
}

const Content = ({ selectedSetting, attendanceSettings, loading, onChange }: Props) => {
  const sortedAttendanceSettings: AttendanceSetting[] = [...attendanceSettings].reverse()
  const currentSetting = attendanceSettingsCollection.currentByPolicy(selectedSetting.policyId)

  return (
    <Box gap="s16">
      {sortedAttendanceSettings.map((setting: AttendanceSetting) => (
        <Item
          key={setting.id}
          current={setting.equals(currentSetting)}
          selected={setting.equals(selectedSetting)}
          attendanceSetting={setting}
          onClick={() => onChange(setting)}
          loading={loading}
        />
      ))}
    </Box>
  )
}

export default observer(Content)
